import React, { useEffect, useState } from "react";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { callAPI } from "../../helper/apiUtils";
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { $crud } from "../../helper/CrudFactory";
import "./InviteProjectUser.css";

const QRCode = require("qrcode.react");

function InviteProjectUser(props) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [company, setCompany] = useState({});
  const [deeplink, setDeepLink] = useState("");
  const [toggleShareLink, setToggleShareLink] = useState(false);
  const [showQrCode, setQrCode] = useState(false);

  let iPhoneText = strings.iphone_recivers_message;
  let iphone = strings.iphone;
  let germenLangDeeplink =
    `${DE.project_receivers_message}\n\n${deeplink}`.replaceAll(
      "project name",
      company?.name
    );
  let engLangDeeplink = `${EN.project_receivers_message
    }\n\n${deeplink.replaceAll("project name", company?.name)}`.replaceAll(
      "project name",
      company?.name
    );
  const receiverMessage = deeplink
    ? isGerm
      ? germenLangDeeplink
      : engLangDeeplink
    : "";
  // const receiverMessage = deeplink
  //   ? `${
  //       strings.project_receivers_message
  //     }\n\n${deeplink}`.replaceAll("project name", company?.name)
  //   : "";

  const getCompanyDetails = async () => {
    const id = props.project_id;
    const { data } = await callAPI(`/building/one/${id}`, {}, "GET");
    await setCompany(data);
  };
  const getInviteLink = async () => {
    const id = props.project_id;
    // const { data } = await callAPI(`/building/${id}/deeplink`, {}, "GET");
    const { data } = await callAPI(
      `/invite-user/deeplink`,
      {
        inviteType: "buildingList",
        buildingList: id,
      },
      "POST"
    );
    if (data.status) {
      let splitToken = data?.deeplinkUrl?.split("/");
      let getToken = splitToken[splitToken?.length - 1];
      let webLinkPayload = {
        data: {
          locallyIndex: true,
          title: "Kjuup",
          ratingAverage: 4.2,
          registraTionToken: getToken,
        },
      };
      window.branch.link(webLinkPayload, (err, link) => {
        setDeepLink(link);
      });
      // setDeepLink(data.deeplinkUrl);
    }
  };
  useEffect(() => {
    getCompanyDetails();
    getInviteLink();
  }, [props.project_id]);

  const handleShareUrl = () => {
    setToggleShareLink(!toggleShareLink);
    setQrCode(false);
  };
  const handleQrCode = () => {
    setToggleShareLink(false);
    setQrCode(!showQrCode);
  };

  const handleCopy = async () => {
    setToggleShareLink(false);
    setQrCode(false);
    navigator.clipboard.writeText(receiverMessage).then((r) => {
      $crud.notify({
        type: "success",
        message: strings.link_copied,
      });
    });
  };
  const handleCancel = async () => {
    setToggleShareLink(false);
    setQrCode(false);
    const id = props.project_id;
    const { data } = await callAPI(`/building/${id}/deeplink`, {}, "DELETE");
    if (data.status) {
      setDeepLink(data.deeplinkUrl);
    }
  };

  return (
    <React.Fragment>
      <div className="w-300 p-0 h-100">
        <div className="company_header  company_border">
          <div class="heading_icon m-0">
            <a
              onClick={(e) => props.handleClose()}
              className="main_heading invite-project-user__back"
            >
              <img
                width={10}
                src={process.env.PUBLIC_URL + "/assets/img/back.svg"}
              />
              {strings.invite_with_link}
            </a>
          </div>
        </div>
        <div className="p-2 company_border">
          {company?.name ? (
            <>

              <div>
                {`${strings.project_sender_message
                  }`.replaceAll("project name", company?.name)}
              </div>
            </>
          ) : (
            <span>Loading...</span>
          )}
        </div>
        <div
          className="profile_name row m-0 text-center pt-2 invite-project-user__actions"
        >
          {/* <div className="col-md-4">
            <div onClick={handleShareUrl} className="pointer">
              <img
                width={20}
                src={process.env.PUBLIC_URL + "/assets/img/Share link.svg"}
              />
              <br />
              <span
                style={{
                  fontSize: "var(--kjuup-type-body)",
                  color: "#f18438",
                }}
              >
                {strings.share_link}
              </span>
            </div>
          </div> */}
          {/* <div className="col-md-4">
            <div onClick={handleQrCode} className="pointer">
              <img
                width={30}
                src={process.env.PUBLIC_URL + "/assets/img/QR Code.svg"}
              />
              <br />
              <span
                style={{
                  fontSize: "var(--kjuup-type-body)",
                  color: "#f18438",
                }}
              >
                {strings.qr_code}
              </span>
            </div>
          </div> */}
          <div className="col-md-4">
            <div onClick={handleCopy} className="pointer">
              <img
                width={30}
                src={process.env.PUBLIC_URL + "/assets/img/Copy link.svg"}
              />
              <br />
              <span className="invite-project-user__action-label">
                {strings.copy_link}
              </span>
            </div>
          </div>
          {/* <div className="col-md-3">
            <div onClick={handleCancel} className="pointer">
              <img
                width={30}
                src={process.env.PUBLIC_URL + "/assets/img/Cancel link.svg"}
              />
              <br />
              <span
                style={{
                  fontSize: "12px",
                  color: "#f18438",
                }}
              >
                {strings.cancel_link}
              </span>
            </div>
          </div> */}
        </div>
        <div className="invite-project-user__expiry">
          <span className="text-center kj-text-caption kj-text-muted">
            {(() => {
              const text = strings.link_expire;
              return text
                .replace('72 hours', '10 days')
                .replace('72 ore', '10 giorni')
                .replace('72 Stunden', '10 Tage')
                .replace('72 heures', '10 jours')
                .replace('72 horas', '10 días')
                .replace('72 uur', '10 dagen')
                .replace('72 timer', '10 dager')
                .replace('72 timmar', '10 dagar')
                .replace('72 tuntia', '10 päivää')
                .replace('72 godziny', '10 dni')
                .replace('72 saat', '10 gün')
                .replace('72 ώρες', '10 ημέρες')
                .replace('72 hodin', '10 dní')
                .replace('72 óra', '10 nap')
                .replace('72 de ore', '10 zile')
                .replace('72 sata', '10 dana')
                .replace('72 ur', '10 dni')
                .replace('72小时', '10天')
                .replace('72 घंटे', '10 दिन')
                .replace('72 ساعة', '10 أيام')
                .replace('72時間', '10日')
                .replace('72시간', '10일')
                .replace('72 giờ', '10 ngày')
                .replace('72 jam', '10 hari')
                .replace('72 மணி', '10 நாட்கள்')
                .replace('72 గంటలు', '10 రోజులు')
                .replace('72 часа', '10 дней')
                .replace('72 часа', '10 дни');
            })()}
          </span>
        </div>

        {toggleShareLink && (
          <div className="mt-3 p-2">
            <h6>{strings.share_on} </h6>
            <WhatsappShareButton className="mr-1" url={receiverMessage}>
              <WhatsappIcon size={30} round={true} />
            </WhatsappShareButton>
            <EmailShareButton className="mr-1" url={receiverMessage}>
              <EmailIcon size={30} round={true} />
            </EmailShareButton>
            <TelegramShareButton className="mr-1" url={receiverMessage}>
              <TelegramIcon size={30} round={true} />
            </TelegramShareButton>
          </div>
        )}
        {showQrCode && (
          <div className="text-center pt-3">
            <QRCode value={receiverMessage} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default InviteProjectUser;
